import { GapError } from '@gap/backend/endpoints/trpc/error-handler/GapError'

export type ShareTokenErrorStatus = 'expired-token' | 'access-denied-token' | 'usage-exceeded-token'

export const shareTokenErrorSnackbarMessages: Record<ShareTokenErrorStatus, string> = {
   'expired-token': 'This token has expired. Please request a new one.',
   'access-denied-token': 'You don\'t have access to this token. Please request a new one.',
   'usage-exceeded-token': 'This token has reached its usage limit. Please request a new one.'
}

/** Maps a share-token error message onto the status that renders its screen. */
export function resolveShareTokenErrorStatus(errorMessage: unknown): ShareTokenErrorStatus | undefined {
   switch (errorMessage) {
      case GapError.messages.token.expired:
         return 'expired-token'
      case GapError.messages.token.accessDenied:
         return 'access-denied-token'
      case GapError.messages.token.usageLimitReached:
         return 'usage-exceeded-token'
      default:
         return undefined
   }
}
